import { render, staticRenderFns } from "./ElementEdit.vue?vue&type=template&id=75fb33da"
import script from "./ElementEdit.vue?vue&type=script&lang=ts"
export * from "./ElementEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports